export type NavCatalogTab = 'professions' | 'services' | 'events';

export const NAV_CATALOG_TABS: { id: NavCatalogTab; label: string }[] = [
  { id: 'professions', label: 'Professions' },
  { id: 'services', label: 'Services' },
  { id: 'events', label: 'Événements' },
];

export type CatalogService = { id: number; name: string };

/** La recherche filtre les pros dont le nom de prestation contient ce libellé. */
export function catalogServiceSearchPath(name: string): string {
  const params = new URLSearchParams({ serviceType: name });
  return `/recherche?${params.toString()}`;
}

/** Séances datées (ateliers, stages, sorties), pas les rendez-vous sur créneau. */
export const CATALOG_EVENTS_SEARCH_PATH = '/recherche?service_mode=event';

export function parseCatalogServices(payload: unknown): CatalogService[] {
  const rows = (payload as { services?: unknown })?.services;
  if (!Array.isArray(rows)) return [];
  return rows
    .map(row => {
      const item = row as { id?: unknown; name?: unknown };
      const id = Number(item.id);
      const name = String(item.name ?? '').trim();
      return { id, name };
    })
    .filter(item => Number.isFinite(item.id) && item.id > 0 && item.name.length > 0)
    .sort((a, b) => a.name.localeCompare(b.name, 'fr'));
}
